const DEFAULT_ITEMS = [
  "Fixed Supply",
  "50 Trillion XVPR",
  "BNB Smart Chain",
  "BEP-20",
  "No Future Minting",
  "Utility First",
  "Community Governance",
  "Security by Design",
];

// Slow editorial marquee. Duplicated content for a seamless loop.
export default function Marquee({ items = DEFAULT_ITEMS }) {
  const row = [...items, ...items];
  return (
    <div className="relative flex overflow-hidden border-y border-white/10 bg-[#050508] py-6" data-testid="marquee">
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-[#030305] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-[#030305] to-transparent" />
      <div className="flex shrink-0 animate-marquee items-center whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="px-8 font-display text-2xl font-bold uppercase tracking-tight text-white/80 sm:text-3xl">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-indigo-500" />
          </span>
        ))}
      </div>
    </div>
  );
}
